// Which "messages left today" wording a count takes. Lithuanian has three
// forms (1 žinutė, 2 žinutės, 10 žinučių, 21 žinutė…); English uses "one" for
// 1 and "many" for everything else.
export type CountForm = 'one' | 'few' | 'many';

export const lithuanianCountForm = (count: number): CountForm => {
    const lastTwo = count % 100;
    const last = count % 10;
    if (lastTwo >= 11 && lastTwo <= 19) {
        return 'many';
    }
    if (last === 1) {
        return 'one';
    }
    if (last >= 2 && last <= 9) {
        return 'few';
    }
    return 'many';
};

export const quotaLabelKey = (
    count: number,
    language: string,
): 'chat_quota_left_one' | 'chat_quota_left_few' | 'chat_quota_left_many' => {
    const englishForm: CountForm = count === 1 ? 'one' : 'many';
    const form = language === 'lt' ? lithuanianCountForm(count) : englishForm;
    return `chat_quota_left_${form}`;
};

// Green for the first half of the day's messages, orange after that, red once
// five or fewer are left.
export const QUOTA_LOW_REMAINING = 5;

export const quotaTone = (remaining: number, limit: number): 'success' | 'warning' | 'error' => {
    if (remaining <= QUOTA_LOW_REMAINING) {
        return 'error';
    }
    return limit - remaining <= limit / 2 ? 'success' : 'warning';
};
